import {sendToBackgroundViaRelay} from '@plasmohq/messaging';

export const updateExtensionToken = async (token: string | null, open = false) => {
  await sendToBackgroundViaRelay<{token: string | null; open: boolean}>({
    // @ts-expect-error
    name: 'auth',
    body: {token, open},
  });
};
